(function () {

	'use strict';

	/*global $:true */

	let cologicSlide = {

		initSlideFunc: function () {

			let that = this;
            $(window).on('resize', function() {
                that.prepareSliders();
                setTimeout(function () {
                     that.sizeSliderImages();
                }, 400);

            });

            //
			// this.showToTop();
			// this.setBurger();
			// this.enableAccordion();
			// // this.navigationHandling();
			// // this.setYoutubeBox();
            //
			// $('.toTopWrapper').click(this.pageToTop);
			// // $(window).scroll(function () {
			// // 	that.setBackgroundImages();
			// // 	that.showToTop();
			// // });
			// // setTimeout(function () {
			// // 	that.setBackgroundImages()
			// // }, 1500);
            //
			// this.equalHeight();
            this.prepareSliders();
		},


        sizeSliderImages: function() {
            $('.teaser-slide-image .sliderBox').each(function () {
               $(this).find('.teaser-rowSetup').each(function () {
                   let putHeight = $(this).width() - 60;
                   // console.log(putHeight);
                   $(this).height(putHeight).parent().parent().height(putHeight).css('min-height', 'unset');
               });
            });
        },

        prepareSliders: function() {
        //return;

        // Alle Multiboxelemente mit der Klasse Slider(N) jeweils zusammenführen
        var hHelper = 0;
        var xHelper = 0;
        var q = 1;
        var $sliderHelper;
        var cClasses;
        let that = this;

        // $('.events-std').each(function (index, value) {
        $('.sliderBox').each(function (index, value) {
            let sliderId = '#'+ $(this).attr('id');
            let sliderNumber = $(this).data('tag-elem-nr');
            let sliderButtons = '#sliderButtonContainer'+ sliderNumber + ' .sliderButton';

            //slider height
            // var highestBox = 0;
            // $('.slide', this).each(function(){
            //     if($(this).height() > highestBox) {
            //         highestBox = $(this).height();
            //     }
            // });
            // // console.log(highestBox);
            // $(this).css({'min-height':(highestBox+70)});
            // // $(this).height(highestBox);

            let sliderArrows = '#sliderArrowContainer'+ sliderNumber;
            // let sliderArrows = '#sliderArrowContainer'+ sliderNumber;
            // cologic.initSlider(sliderId, sliderArrows);
            cologic.initSlider(sliderId, sliderButtons, sliderArrows);
            //initSlider($sliderId);
        });
    },

    initSlider: function(_sliderId, _sliderButton, _arrowCont){
    // initSlider: function(_sliderId, _sliderButton, _arrowCont){
        $(_sliderId).iosSlider({
            snapToChildren: true,
            scrollbar: false,
            scrollbarDrag: false,
            scrollbarHeight: '15px',
            navSlideSelector: $(_sliderButton),
            navPrevSelector: $(_arrowCont+' .prev'),
            navNextSelector: $(_arrowCont+' .next'),
            autoSlide: true,
            autoSlideTimer: 5000,
            // autoSlideTransTimer: 1,
            autoSlideTransTimer: 1000,
            desktopClickDrag: true,
            infiniteSlider: true,
            responsiveSlideContainer: true,
            responsiveSlides: true,
            onSlideChange: cologic.slideChange,
            onSliderResize: cologic.sliderUpdate
        });
    },

    sliderUpdate: function(args) {
            if(args){
                args.sliderObject.prevObject.iosSlider('update');
                // args.sliderObject.iosSlider('update');
                // console.log('sliderUpdate');
                // console.log(args.sliderObject.prevObject);
            }
        // args.sliderContainerObject.each(function (index, value) {
        //     $(this).css({'min-height':'auto'});
        //     //slider height
        //     var highestBox = 0;
        //     $('.slide', this).each(function(){
        //         if($(this).height() > highestBox) {
        //             highestBox = $(this).height();
        //         }
        //     });
        //     // console.log(highestBox);
        //     // $(this).css({'min-height':(highestBox+70)});
        //     // $(this).height(highestBox);
        //
        // });
    },

    sliderLoaded: function(args) {
            if(args.data.numberOfSlides < 2){
                let sliderNumber = $(args.sliderContainerObject).data('tag-elem-nr');
                $('#sliderButtonContainer-'+sliderNumber).hide();
            }
        // console.log($(args.slider).data('tag-elem-nr'));
        // console.log(args)
        // console.log(numberOfSlides)

        // args.sliderObject.iosSlider('update');
        // args.sliderContainerObject.each(function (index, value) {
        //     $(this).css({'min-height':'auto'});
        //     //slider height
        //     var highestBox = 0;
        //     $('.slide', this).each(function(){
        //         if($(this).height() > highestBox) {
        //             highestBox = $(this).height();
        //         }
        //     });
        //     // console.log(highestBox);
        //     // $(this).css({'min-height':(highestBox+70)});
        //     // $(this).height(highestBox);
        //
        // });
    },


    slideChange: function(args) {
        if($('.sliderButton').length>0){
            $('#sliderButtonContainer'+args.sliderContainerObject.data('tag-elem-nr')+' .sliderButton').removeClass('selected');
            $('#sliderButtonContainer'+args.sliderContainerObject.data('tag-elem-nr')+' .sliderButton:eq(' + (args.currentSlideNumber - 1) + ')').addClass('selected');
            // $('#'+args.sliderContainerObject.attr('id')+' .sliderButton').removeClass('selected');
            // $('#'+args.sliderContainerObject.attr('id')+' .sliderButton:eq(' + (args.currentSlideNumber - 1) + ')').addClass('selected');

        }
    },




};

	//------------------------------------

	//gemeinsam verfügbar machen
	if (typeof (cologic) === 'undefined')
		window.cologic = {};
	$.extend(cologic, cologicSlide);
}());